import { useAuth0 } from '@auth0/auth0-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateUserAuth0 } from '../../../api/auth0Api';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';

const useUpdateUser = () => {
  const queryClient = useQueryClient();
  const { auth0Id } = useParams();
  const { getAccessTokenSilently } = useAuth0();
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  return useMutation({
    mutationFn: async (values) => {
      toast.loading('Actualizando usuario...', {
        id: 'update-user',
      });
      const token = await getAccessTokenSilently();
      return await updateUserAuth0(token, auth0Id, values);
    },
    onSuccess: async () => {
      await sleep(1000);
      queryClient.invalidateQueries(['user', auth0Id]);
      queryClient.invalidateQueries(['all-users']);
      toast.success('Se ha actualizado el usuario con éxito.');
    },
    onError: (error) => {
      if (error?.response?.data?.message === 'The user already exists.') {
        return toast.error('Ya existe un usuario con ese email.');
      }
      toast.error('Se ha producido un error al actualizar el usuario.');

      console.log('error', error?.response?.data?.message);
    },
    onSettled: () => {
      toast.dismiss('update-user');
    },
  });
};

export default useUpdateUser;
